import React from "react";
import PropTypes from "prop-types";
import cx from 'classnames';
import { Popup } from 'semantic-ui-react';

const Marker = props => {

	const {
		color,
		showTooltip,
		text,
		onClickTooltip
	} = props;
	const size = props.size && !isNaN(props.size) ? props.size : 0;
	const onClick = (value) => {
		return () => onClickTooltip(value);
	};

	const wrapperClassNames = cx("fa-stack","fa-" + size + "x","map-marker",(color ? color : "blue"));
	const wrapperStyle = { bottom: size + 'em', left: '-' + (size/2) + 'em' };
	const mapMarkerClassNames = cx("fa","fa-map-marker","fa-stack-" + size + "x");
	const circleClassNames = cx("fa","fa-circle","fa-stack-"+ size + "x");
	const circlePositionStyle = { top: (4*size) + 'px' };

	if(text)
	{
		const markerIcon = (<span className={wrapperClassNames} style={wrapperStyle} onMouseEnter={onClick(true)} onMouseLeave={onClick(false)}>
			<i className={mapMarkerClassNames}/>
			<i className={circleClassNames} style={circlePositionStyle}/>
		</span>);

		return (<Popup trigger={markerIcon} content={text} />);
	}
	else
	{
		const markerIcon = (<span className={wrapperClassNames} style={wrapperStyle}>
			<i className={mapMarkerClassNames}/>
			<i className={circleClassNames} style={circlePositionStyle}/>
		</span>);
		return markerIcon;
	}
};

Marker.propTypes = {
	text: PropTypes.string,
	showTooltip: PropTypes.bool,
	onClickTooltip: PropTypes.func,
	color: PropTypes.string,
	size: PropTypes.number
};
Marker.defaultProps = {
	size: 2
};

export default Marker;